import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import * as actions from './actions';
import * as types from './types';
import { ErrorUtils } from 'utils';
import { getProfileRequest } from '../api';
import { PartnerUser } from '../../users/ts/PartnerUser';

function* profileSaga() {
  try {
    const { data: user } = (yield call(getProfileRequest)) as AxiosResponse<PartnerUser>;

    yield put(actions.profileSuccess(user));
  } catch (error) {
    const errMsg = ErrorUtils.convertError(error);
    yield put(actions.profileFailed(errMsg));
  }
}

function* userSaga() {
  yield takeLatest(types.PROFILE_REQUEST, profileSaga);
}

export default userSaga;
